const TEMPLATE = `
<section class="precision-laboratory fade-up">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <p class="section-label" data-animate-child>Про нас</p>
            </div>
            <div class="col-lg-6 col-md-6" style="margin-bottom: 24px !important;">
                <h3 data-animate-child data-delay="200">
                    Точність у діагностиці
                </h3>
                <p data-animate-child data-delay="400">
                    Богомолецька медична лабораторія (BML) прагне надавати точні та швидкі діагностичні послуги. Ми
                    поєднуємо передові технології та експертний аналіз для отримання надійних результатів і
                    підтримки медичних працівників.
                </p>
                <p data-animate-child data-delay="600">
                    BML поєднує інновації та експертизу для надання точних діагностичних рішень. Наша відданість
                    якості та точності робить нас надійним партнером для медичних працівників та клінік.
                </p>
                <a href="/about-us" data-animate-child data-delay="800">
                    Дізнатись більше
                </a>
            </div>
        </div>
        <div class="video-section" data-animate-child data-delay="1000">
            <div class="video-wrapper" data-content="youtube-video" data-page="about-work" data-attribute="video"
                 data-original-attribute="video">
                <!-- <img src="images/video/image.png" alt="Мікроскопія в RMI" class="video-thumbnail"> -->
                <button class="play-button"></button>
            </div>
        </div>
    </div>
</section>
`;

class BmlAboutUsStats extends HTMLElement {
    connectedCallback() { if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE; }
}
customElements.define('bml-about-us-stats', BmlAboutUsStats);
